import { render, staticRenderFns } from "./ForumPagination.vue?vue&type=template&id=195373ca&"
import script from "./ForumPagination.vue?vue&type=script&lang=js&"
export * from "./ForumPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports